import { Rocket } from '@mui/icons-material'
import { Box, Tooltip, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { track, eventTypes } from 'torqcloud-ui'

import type { PromptBoxForm, PromptBoxProps } from './PromptBox.tsx'

interface PromptBoxDeepResearchButtonProps extends Pick<PromptBoxProps, 'variant'> {}

export default function PromptBoxDeepResearchButton({ variant }: PromptBoxDeepResearchButtonProps) {
  const { control, register } = useFormContext<PromptBoxForm>()
  return (
    <Controller
      name="enableDeepResearch"
      control={control}
      render={({ field }) => {
        return (
          <Tooltip title="Enable deep research tool">
            <label htmlFor={field.name}>
              <Box
                sx={{
                  display: 'flex',
                  color: t => (field.value ? t.colors.base[30] : t.colors.base[45]),
                  border: '1px solid',
                  borderColor: t => (field.value ? t.colors.base[30] : t.colors.base[45]),
                  borderRadius: '6px',
                  gap: '4px',
                  padding: '7px 12px',
                  userSelect: 'none',
                  fontWeight: 500,
                  cursor: 'pointer',
                  '&:hover': {
                    color: t => (field.value ? t.colors.base[30] : t.colors.base[20]),
                    borderColor: t => (field.value ? t.colors.base[30] : t.colors.base[20]),
                  },
                }}
              >
                <Rocket fontSize="small" />
                {variant === 'large' && <Typography>Deep Research</Typography>}
                <input
                  id={field.name}
                  type="checkbox"
                  style={{ display: 'none' }}
                  {...register('enableDeepResearch', {
                    onChange: e => track(eventTypes.DEEP_RESEARCH_TOGGLED, { enabled: e.target.checked }),
                  })}
                />
              </Box>
            </label>
          </Tooltip>
        )
      }}
    />
  )
}
